import React from "react";
import PagesTitleCol from "../components/cols/PagesTitleCol";
import RiderLoginForm from "../components/Sections/RiderLoginForm";
import RiderSection1 from "../components/Sections/RiderSection1";
import Body from "../components/Wrapper/Body";

export default function Rider() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  return (
    <Body>
      <div className={"hideOnDesktop"}>
      <PagesTitleCol
        description="Become a rider with Sprinterwave"
        title="Rider"
        bg_imageName="rider"
      />
      </div>

      {/* <RiderSection1 /> */}
      <RiderLoginForm />
    </Body>
  );
}
